const GA_ID = 'G-GD7JDGZGZR';

export const scheduleAnalyticsLoad = (measurementId = GA_ID) => {
  if (!measurementId || typeof window === 'undefined' || typeof document === 'undefined') {
    return () => {};
  }

  if (window.__gtagLoaded || window.gtag) {
    return () => {};
  }

  const loadAnalytics = () => {
    if (window.__gtagLoaded || window.gtag) {
      return;
    }

    window.__gtagLoaded = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ||
      function gtag() {
        window.dataLayer.push(arguments);
      };

    window.gtag('js', new Date());
    window.gtag('config', measurementId, { anonymize_ip: true });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.dataset.gtag = measurementId;
    document.head.appendChild(script);
  };

  if ('requestIdleCallback' in window) {
    const idleId = window.requestIdleCallback(loadAnalytics, { timeout: 2000 });
    return () => {
      if ('cancelIdleCallback' in window) {
        window.cancelIdleCallback(idleId);
      }
    };
  }

  const timeoutId = window.setTimeout(loadAnalytics, 1500);
  return () => window.clearTimeout(timeoutId);
};
